// Navigation bar component
// Handles user authentication UI and navigation controls
import React, { useState } from 'react';
import { UserCircle, FilePlus } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import SignInForm from './SignInForm';
import { Link, useNavigate } from 'react-router-dom';
import './NavBar.css';
import SignInModal from './SignInModal';

function NavBar() {
  // Get authentication context
  const { user, signOut } = useAuth();
  // Control visibility of sign-in modal
  const [showSignIn, setShowSignIn] = useState(false);
  const navigate = useNavigate();

  // Handler for initiating sign-in process
  const handleSignIn = () => {
    setShowSignIn(true);
  };

  const handleSignInClick = () => {
    navigate('/signin');
  };

  // Handler for signing out
  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/signin');
    } catch (error) {
      console.error('Sign out failed:', error);
    }
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold">
              ClickHeard
            </Link>
          </div>
          <div className="flex items-center">
            {user ? (
              <>
                <span className="mr-4">{user.email}</span>
                <button
                  onClick={handleSignOut}
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <Link
                to="/signin"
                className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>

      {showSignIn && (
        <SignInModal onClose={() => setShowSignIn(false)} />
      )}
    </nav>
  );
}

export default NavBar;